module.exports = __webpack_public_path__ + "static/img/photo.f8476b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/photo.png
// module id = 1qOY
// module chunks = 0